<template>
    <div>
        <div class="loans">
            <div class="part-one">
                <div class="base-title">
                    <div class="part-one-content">
                        <img class="part-one-title-img" src="../assets/imgs/craft/part-1-title.png" alt="" />
                        <div class="part-text part-one-text">
                            加快构建灵活开放高效的引才机制，通过“双招双引”支持顶尖科技创新团队来蓉发展，持续优化招商引智营商环境。
                        </div>
                    </div>
                </div>
            </div>
            <div class="part-two">
                <img src="../assets/imgs/19/title1.png" class="part-two-title-img" />
                <div class="part-text">
                    我市“双招双引”引进的顶尖科技创新团队（以下简称团队）。团队所在企业以顶尖科技人才为引领，拥有国际一流、国内领先的创新技术且产品（含技术应用）市场前景广阔，符合成都产业发展方向，能够积极推动我市强链、补链和延链的重点产业发展方向相关产业。
                </div>
            </div>
            <div class="part-three">
                <img src="../assets/imgs/19/title2.png" class="part-two-title-img" />
                <div class="part-three-items">
                    <img src="../assets/imgs/19/part-two-1.png" class="part-three-items-img" />
                    <div class="part-three-items-text">
                        给予每个团队1000万元资金资助，主要用于高层次人才引进培养、技术攻关、产品测试、核心成员工作和生活改善等方面。
                    </div>
                </div>
                <div class="part-three-items">
                    <img src="../assets/imgs/19/part-two-2.png" class="part-three-items-img" />
                    <div class="part-three-items-text">
                        <div>
                            给予团队最高3张“蓉城人才绿卡”市级卡，在其核心成员中统筹分配，按规定提供人才安居、子女入学、健康医疗、金融扶持等方面的服务保障。
                        </div>
                    </div>
                </div>
            </div>
            <div class="part-four">
                <img src="../assets/imgs/19/title3.png" class="part-two-title-img" />
                <div class="part-title part-two-title" style="margin-top: 1.44rem">
                    申报单位应同时符合以下条件：
                </div>
                <div class="part-two-content">
                    <div style="margin-bottom: 0.22rem; position: relative">
                        <div class="part-two-dot">1</div>
                        在成都市行政区域内依法登记注册，具有独立法人资格的企业，属于《成都市人才工作领导小组办公室等3部门关于印发＜成都市“双招双引”顶尖科技创新团队支持办法＞的通知》（成人才办〔2022〕1号）有效期内我市新引进的急需紧缺关键性项目。
                    </div>
                    <div style="margin-bottom: 0.22rem; position: relative">
                        <div class="part-two-dot">2</div>
                        申请资助奖励的团队及其所在企业须满足《成都市人才工作领导小组办公室等3部门关于印发＜成都市“双招双引”顶尖科技创新团队支持办法＞的通知》（成人才办〔2022〕1号）的认定条件。
                    </div>
                    <div style="position: relative">
                        <div class="part-two-dot">3</div>
                        申报企业及团队未被国家、省、市相关部门纳入失信主体名单，未被实施失信惩戒，未被明确限制申请财政性资金项目、政策性资金和财税政策扶持。
                    </div>
                </div>
            </div>
            <div class="part-five" style="padding-top: 1.5rem">
                <img src="../assets/imgs/10/title4.png" class="part-two-title-img" />
                <div class="part-title part-four-title" style="margin-bottom: 0.8rem">
                    如何申请“双招双引”顶尖科技创新团队奖励?
                </div>
                <div class="part-three-items">
                    <div class="part-four-texts" style="position: relative">
                        <div class="part-two-dot">1</div>
                        市委人才办、市投促局、市科技局发布申报通知；
                    </div>
                    <div class="part-four-texts" style="position: relative">
                        <div class="part-two-dot">2</div>
                        企业申报；
                    </div>
                    <div class="part-four-texts" style="position: relative">
                        <div class="part-two-dot">3</div>
                        区（市）县组织、投促、科技部门初审；
                    </div>
                    <div class="part-four-texts" style="position: relative">
                        <div class="part-two-dot">4</div>
                        区（市）县人民政府审定上报；
                    </div>
                    <div class="part-four-texts" style="position: relative">
                        <div class="part-two-dot">5</div>
                        市投促局组织市级相关部门开展形式审查；
                    </div>
                    <div class="part-four-texts" style="position: relative">
                        <div class="part-two-dot">6</div>
                        市投促局、市科技局联合组织专家评审；
                    </div>
                    <div class="part-four-texts" style="position: relative">
                        <div class="part-two-dot">7</div>
                        评审结果意见报市委人才工作领导小组审议；
                    </div>
                    <div class="part-four-texts" style="position: relative">
                        <div class="part-two-dot">8</div>
                        社会公示；
                    </div>
                    <div class="part-four-texts" style="position: relative">
                        <div class="part-two-dot">9</div>
                        签订顶尖科技创新团队引进协议书；
                    </div>
                    <div class="part-four-texts" style="
                                        position: relative;
                                        border: none;
                                        padding-bottom: 0;
                                    ">
                        <div class="part-two-dot">10</div>
                        拨付资金。
                    </div>
                </div>
            </div>
            <!-- 咨询 -->
            <img src="../assets/imgs/19/hint.png" style="width: 6.85rem; height: 1.17rem; margin-top: 0.22rem" />
            <div class="call">
                <div class="part-five-items" v-for="(item, index) in phoneNumber" :key="index">
                    <a :href="`tel:` + `${item}`" style="text-decoration: none; font-weight: bold">{{ item }}</a>
                    <!-- <a v-if="index === 2" href="tel:028-61883696"
                        style="text-decoration: none; font-weight: normal">/61883696</a> -->
                </div>
            </div>
        </div>
        <call phone="028-61886976"></call>
    </div>
</template>

<script>
import call from "../components/call.vue";
export default {
    name: "craft",
    components: {
        call,
    },
    data() {
        return {
            phoneNumber: [
                "028-61886976",
                "028-61881742",
                "028-68772540",
                "028-86360059",
                "028-85151257",
                "028-86726790",
                "028-86943359",
                "028-87707510",
                "028-85575208",
                "028-84307576",
                "028-84857966",
                "028-68036162",
                "028-83012666",
                "028-82632093",
                "028-85801189",
                "028-69504602",
                "028-69700046",
                "028-27028530",
                "028-61721730",
                "028-83871509",
                "028-88773339",
                "028-82272151",
                "028-84931320",
                "028-88228323",
                "028-88552881",
            ],
        };
    },
    created() { },
    mounted() { },
    computed: {},
    methods: {},
};
</script>

<style lang="scss" scoped>
.loans {
    background: #0839b7;
    overflow: hidden;
    padding: 0.24rem 0.12rem;
    padding-bottom: 1.65rem;
    box-sizing: border-box;
    width: 100vw;
    height: 100vh;
    overflow-y: auto;

    .part-title {
        font-size: 0.34rem;
        //font-family:: PingFang SC-Bold, PingFang SC;
        font-weight: bold;
        color: #333333;
        position: relative;

        &::before {
            position: absolute;
            content: "";
            width: 0.28rem;
            height: 0.28rem;
            border-radius: 50%;
            background: none;
            border: 0.06rem solid #ff6d60;
            box-sizing: border-box;
            top: 0.08rem;
            left: -0.2rem;
        }
    }

    .part-text {
        font-size: 0.26rem;
        //font-family:: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #4e4e4e;
        line-height: 0.44rem;
        text-align: left;
    }

    .part-one {
        height: 6.88rem;
        width: 7.5rem;
        margin: 0 auto;
        box-sizing: border-box;

        .base-title {
            width: 7.26rem;
            height: 5.6rem;
            background: url(../assets/imgs/19/base-title.png);
            background-size: 100% 100%;
            position: relative;

            .part-one-content {
                width: 6.85rem;
                background: #ffffff;
                border-radius: 10px;
                position: absolute;
                top: 4.02rem;
                left: 50%;
                transform: translateX(-50%);
                padding-left: 0.36rem;
                padding-right: 0.37rem;
                padding-bottom: 0.35rem;
                box-sizing: border-box;

                .part-one-title-img {
                    position: absolute;
                    top: -0.32rem;
                    left: 0;
                    width: 6.86rem;
                    height: 1.12rem;
                }

                .part-one-title {
                    margin-top: 0.98rem;
                    text-align: left;
                    margin-left: 0.34rem;
                }

                .part-one-text {
                    margin-top: 1.12rem;
                }
            }
        }
    }

    .part-two-title-img {
        width: 7.03rem;
        height: 1.37rem;
        top: 0;
        left: -0.18rem;
        position: absolute;
    }

    .part-two {
        margin-left: 0.02rem;
        width: 6.85rem;
        margin-top: 0.22rem;
        background: #fff;
        border-radius: 10px;
        padding-left: 0.53rem;
        padding-right: 0.3rem;
        box-sizing: border-box;
        margin: 0 auto;
        margin-top: 0.22rem;
        border: 0.00001px solid transparent;
        position: relative;
        padding-top: 1.5rem;
        padding-bottom: 0.35rem;
    }

    .part-three {
        margin-left: 0.02rem;
        width: 6.85rem;
        margin-top: 0.22rem;
        background: #e8eeff;
        border-radius: 10px;
        box-sizing: border-box;
        margin: 0 auto;
        margin-top: 0.22rem;
        border: 0.00001px solid transparent;
        position: relative;
        padding: 0 0.3rem 0.1rem 0.3rem;
        padding-top: 1.8rem;

        .part-three-items {
            width: 6.35rem;
            background: #ffffff;
            border-radius: 10px;
            padding-top: 0.68rem;
            padding-left: 0.31rem;
            padding-right: 0.31rem;
            box-sizing: border-box;
            position: relative;
            margin-bottom: 0.52rem;
            padding-bottom: 0.35rem;

            .part-three-items-text {
                font-size: 0.26rem;
                //font-family:: PingFang SC-Medium, PingFang SC;
                font-weight: 500;
                color: #4e4e4e;
                text-align: left;
                line-height: 0.44rem;
            }

            .part-three-items-img {
                position: absolute;
                width: 3.74rem;
                height: 0.67rem;
                left: 50%;
                transform: translateX(-50%);
                top: -0.32rem;
            }
        }
    }

    .part-four {
        margin-left: 0.02rem;
        width: 6.85rem;
        margin-top: 0.22rem;
        background: #e8eeff;
        border-radius: 10px;
        padding-left: 0.33rem;
        padding-right: 0.3rem;
        box-sizing: border-box;
        margin: 0 auto;
        margin-top: 0.22rem;
        border: 0.00001px solid transparent;
        position: relative;

        .part-two-title {
            text-align: left;
            margin-left: 0.33rem;

            &::before {
                position: absolute;
                content: "";
                width: 0.28rem;
                height: 0.28rem;
                border-radius: 50%;
                background: none;
                border: 0.06rem solid #ff6d60;
                box-sizing: border-box;
                top: 0.08rem;
                left: -0.35rem;
            }
        }

        .part-two-content {
            margin-top: 0.2rem;
            margin-bottom: 0.3rem;
            width: 6.22rem;
            background: #ffffff;
            border-radius: 10px;
            box-sizing: border-box;
            padding: 0.34rem 0.24rem 0.25rem 0.67rem;
            font-size: 0.26rem;
            //font-family:: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #4e4e4e;
            line-height: 0.44rem;

            text-align: left;

            .part-two-dot {
                position: absolute;
                top: 0;
                left: -0.46rem;
                width: 0.36rem;
                height: 0.36rem;
                display: inline-flex;
                align-items: center;
                justify-content: center;
                color: #fff;
                font-size: 0.26rem;
                background: #739bfe;
                border-radius: 50%;
            }
        }
    }

    .part-five {
        width: 6.85rem;
        background: #e8eeff;
        border-radius: 10px;
        margin-left: 0.02rem;
        margin-top: 0.22rem;
        box-sizing: border-box;
        margin: 0 auto;
        margin-top: 0.22rem;
        border: 0.00001px solid transparent;
        position: relative;
        padding: 1.84rem 0.25rem 0 0.25rem;
        padding-bottom: 0.35rem;

        .part-four-title {
            text-align: left;
            margin-left: 0.35rem;

            &::before {
                position: absolute;
                content: "";
                width: 0.28rem;
                height: 0.28rem;
                border-radius: 50%;
                background: none;
                border: 0.06rem solid #ff6d60;
                box-sizing: border-box;
                top: 0.08rem;
                left: -0.38rem;
            }
        }

        .part-three-items {
            width: 6.35rem;
            // height: 1.45rem;
            background: #ffffff;
            border-radius: 10px;
            padding-top: 0.68rem;
            padding-left: 0.31rem;
            padding-right: 0.31rem;
            box-sizing: border-box;
            position: relative;
            padding-bottom: 0.35rem;

            .part-three-items-text {
                font-size: 0.26rem;
                //font-family:: PingFang SC-Medium, PingFang SC;
                font-weight: 500;
                color: #4e4e4e;
                text-align: center;
            }

            .part-four-texts {
                box-sizing: border-box;
                position: relative;
                font-size: 0.26rem;
                padding-left: 0.33rem;
                //font-family:: PingFang SC-Medium, PingFang SC;
                font-weight: 500;
                color: #4e4e4e;
                text-align: left;
                padding-bottom: 0.35rem;
                border-left: 0.02rem dashed #739bfe;

                .part-two-dot {
                    position: absolute;
                    top: 0;
                    left: -0.18rem;
                    width: 0.36rem;
                    height: 0.36rem;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    color: #fff;
                    font-size: 0.26rem;
                    background: #739bfe;
                    border-radius: 50%;
                }
            }
        }
    }

    .call {
        width: 6.85rem;
        height: 16.47rem;
        margin: 0 auto;
        margin-top: 0.22rem;
        border-radius: 10px;
        background: url(../assets/imgs/19/part-five.png);
        background-size: 100% 100%;
        position: relative;
        box-sizing: border-box;
        padding-top: 2.58rem;
        padding-left: 2.9rem;

        .part-five-items {
            width: 3.67rem;
            // background: #ccc;
            height: 0.55rem;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 0.21rem;
            //font-family:: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            // color: #4e4e4e;
        }
    }
}
</style>
